export const focusSelectedOption = (optionRefs, selectedOption, options) => {
    const selectedIdx = options.findIndex(
        option => option.id === selectedOption?.id
    );
    if (selectedIdx >= 0) {
        focusDomElementByIdx(selectedIdx, optionRefs);
    }
};

const getFocusedOptionIdx = optionRefs => {
    return optionRefs.current.findIndex(el => el === document.activeElement);
};

const focusDomElementByIdx = (idx, optionRefs) => {
    const el = optionRefs?.current?.[idx];
    if (el && typeof el.focus === "function") {
        el.focus();
    }
};

export const focusNextOption = optionRefs => {
    const idx = getFocusedOptionIdx(optionRefs);
    const nextIdx = idx === -1 ? 0 : idx + 1;
    focusDomElementByIdx(nextIdx, optionRefs);
};

export const focusPrevOption = optionRefs => {
    const idx = getFocusedOptionIdx(optionRefs);
    const prevIdx = idx === -1 ? optionRefs.current.length - 1 : idx - 1;
    focusDomElementByIdx(prevIdx, optionRefs);
};
